import { useTranslation } from 'next-i18next'

import { TRACK_PAGE_TYPE } from '@src/quince-site-common/src/domains/PageTypes'
import { AppInstallAccounts } from '@src/quince-site-common/src/organisms/appLayout/molecules/footer/molecules/app-install/app-install-accounts'
import { useAppInstallAccountsPresenter } from '@src/quince-site-common/src/organisms/appLayout/molecules/footer/molecules/app-install/app-install.presenter'

import WishlistShareSection from '../wishlist-share-section'
import { WishlistShareSectionProps } from '../wishlist-share-section/wishlist-share-section'

import styles from './wishlist-heading.module.scss'

type PropType = {
  name?: string
  isSelfWishlist?: boolean
} & Pick<WishlistShareSectionProps, 'wishListProductList'>

function WishlistHeadingLegacy({ name, isSelfWishlist, wishListProductList }: PropType) {
  const { t } = useTranslation()
  const { shouldRender: shouldRenderAppInstallAccounts } = useAppInstallAccountsPresenter({ placement: 'wishlist' })

  if (shouldRenderAppInstallAccounts) {
    return (
      <div className={styles.wishlistHeadingWrapper}>
        <WishlistHeadingLegacyContent
          name={name}
          isSelfWishlist={isSelfWishlist}
          wishListProductList={wishListProductList}
          showCompactLayout
        />
        <AppInstallAccounts
          trackPageType={TRACK_PAGE_TYPE.WISHLIST}
          placement="wishlist"
          desktopConfig={{ title: t('get_the_app'), qrAlt: t('app_qr_alt') }}
          mobileConfig={{
            title: t('keep_track_fav_items'),
            actionLabel: t('get_the_app'),
          }}
        />
      </div>
    )
  }

  return (
    <WishlistHeadingLegacyContent
      name={name}
      isSelfWishlist={isSelfWishlist}
      wishListProductList={wishListProductList}
    />
  )
}

type WishlistHeadingLegacyContentProps = PropType & {
  showCompactLayout?: boolean
}

function WishlistHeadingLegacyContent({
  name,
  isSelfWishlist,
  wishListProductList,
  showCompactLayout,
}: WishlistHeadingLegacyContentProps) {
  const { t } = useTranslation('wishlist')
  return (
    <div className={showCompactLayout ? styles.headingWrapperCompact : styles.headingWrapper}>
      <h1 className={showCompactLayout ? styles.headingCompact : styles.heading}>
        {name ? t('favorites_possessive', { name: name }) : t('my_favorites')}
      </h1>
      {name ? <div className={styles.subHeading}>{t('heres_whats_on_their_wishlist')}</div> : null}
      {isSelfWishlist ? <WishlistShareSection wishListProductList={wishListProductList} /> : null}
    </div>
  )
}

export default WishlistHeadingLegacy
